










import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { GlobalHelper } from "@/helper/global-helper";
import { ErrorBag, Validator } from "vee-validate";
import { PageStore, PageStores } from "@/store/modules/page-store";
import Spinner from "@/components/Spinner.vue";
import TOMFragebogenEditor from "./TOMFragebogen-Editor.vue";

Component.registerHooks(["beforeRouteLeave"]);

@Component({
  components: {
    Spinner,
    TOMFragebogenEditor,
  },
})
export default class TOMFragebogenAdministration extends Vue {
  public onSubmit() {}

  public fragebogen = { Id: "0", TomBausteine: [] };

  beforeRouteLeave(from: any, to: any, next: any) {
    (this.$refs["Editor"] as any).handleRouteLeave(from, to, next);
  }
}
